import _ from "lodash";
import React from "react";
import { Form, Spinner } from "react-bootstrap";

import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { ActivateIcon } from "../../../components/icons/ActivateIcon";
import type { Organization } from "../../../hooks/reactQueryHooks/useSubscriptions";

interface IDataBlock {
  name: string;
  title: string;
  value: string;
}

const dataBlocks: IDataBlock[] = [
  {
    name: "name",
    title: "First and last name",
    value: "",
  },
  {
    name: "email",
    title: "Email",
    value: "",
  },
  {
    name: "tenant",
    title: "Tenant",
    value: "",
  },
  {
    name: "subscriptionName",
    title: "Subscription name",
    value: "",
  },
  {
    name: "subscriptionId",
    title: "Subscription ID",
    value: "",
  },
  {
    name: "status",
    title: "Subscription status",
    value: "",
  },
  {
    name: "offerId",
    title: "Offer ID",
    value: "",
  },
  {
    name: "planId",
    title: "Plan ID",
    value: "",
  },
  {
    name: "organizationId",
    title: "Organization",
    value: "",
  },
];

interface IProps {
  name: string;
  email: string;
  tenant: string;
  subscriptionName: string;
  subscriptionId: string;
  status: string;
  offerId: string;
  planId: string;
  isActive: boolean;
  isLoading?: boolean;
  onActivate: () => void;
  getStarted: () => void;
  handleOrganizationChange: (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => void;
  hasError?: boolean;
  organizationId: string;
  selectedOrganization: string;
  organizations: Organization[];
}

const ActivateComponent: React.FC<IProps> = props => {
  const {
    isActive,
    isLoading = false,
    onActivate,
    getStarted,
    handleOrganizationChange,
    hasError = false,
    organizations,
    selectedOrganization,
    organizationId,
  } = props;

  const headerTitle =
    props?.status !== "subscribed"
      ? "Activate your subscription"
      : "Subscription already activated";

  const headerSubTitle =
    props?.status !== "subscribed"
      ? "Review the information below and activate your CogCache subscription."
      : "Review the active CogCache subscription information below.";

  const buttonText =
    props?.status !== "subscribed"
      ? "Activate subscription"
      : "Continue to your account";

  const callback = props?.status !== "subscribed" ? onActivate : getStarted;

  return (
    <div className="w-100 h-100 activate-component">
      <div className="h-100 activate-component__content">
        <div className="activate-component__logo">
          <img
            alt="Logo"
            src={toAbsoluteUrl("/media/logos/tc-logo-light.svg")}
            className="theme-light-show loaderimg"
          />
          <img
            alt="Logo"
            src={toAbsoluteUrl("/media/logos/tc-logo-dark.svg")}
            className="theme-dark-show loaderimg"
          />
        </div>
        <div className="activate-component__header">{headerTitle}</div>
        <div className="activate-component__subheader">{headerSubTitle}</div>
        <div className="activate-component__data">
          {dataBlocks.map((dataBlock, index) => {
            return (
              <div key={index} className="activate-component__data-block">
                <div className="activate-component__data-block-title">
                  {dataBlock.title}
                </div>
                {dataBlock.name === "organizationId" &&
                !_.get(props, `${dataBlock.name}`) ? (
                  <Form.Select onChange={handleOrganizationChange}>
                    <option key="blankChoice" hidden>
                      Choose organization
                    </option>
                    {organizations.map((organization, index) => {
                      return (
                        <option key={index} value={organization.id}>
                          {`${organization.name} ${
                            organization.tenantId
                              ? `(${organization.tenantId})`
                              : ""
                          }`}
                        </option>
                      );
                    })}
                  </Form.Select>
                ) : (
                  <div className="activate-component__data-block-value">
                    {_.get(props, `${dataBlock.name}`, dataBlock.value)}
                  </div>
                )}
              </div>
            );
          })}
          <button
            className="w-100 btn btn-primary activate-component__activate-button"
            disabled={
              isActive ||
              isLoading ||
              (!organizationId && !selectedOrganization)
            }
            onClick={callback}
          >
            {buttonText}
            {isLoading ? (
              <Spinner
                className="ms-2"
                size="sm"
                animation="border"
                data-testid="loading-spinner"
              />
            ) : (
              <ActivateIcon />
            )}
          </button>
        </div>
        {hasError && (
          <div className="onboarding-error-message">
            <div className="loading-text">
              We&#39;re sorry! Something went wrong and we couldn&#39;t activate
              your CogCache subscription. Please try again later.
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export { ActivateComponent };
